// AWS Amplify Configuration for Mobile PWA
// Update these values after running Terraform

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'eu-central-1_XXXXXXXX', // Update after Terraform
      userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || 'XXXXXXXXXXXXXXXXXXXXXXXXXX', // Update after Terraform
      region: process.env.REACT_APP_REGION || 'eu-central-1',
      loginWith: {
        email: true,
        username: false,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: false,
      },
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_S3_BUCKET || 'slatu-inspection-transcripts-dev', // Update after Terraform
      region: process.env.REACT_APP_AWS_REGION || 'eu-central-1',
    },
  },
};

export default awsConfig;
